module.exports = __webpack_public_path__ + "img/birdcage2.7a25d246.png";